/** @format */

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';
import { useDispatch, useSelector } from 'react-redux';
import { newPlatformResellerConstants } from '../../../modules/newplatformreseller/actions';
import { newPlatformResellerReducersType } from '../../../modules/newplatformreseller/newReducers';
import Filter from '../../../interfaces/forms/Filter';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { Auth } from '../../../modules/auth/Auth';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { PlatformResellerCollectionInterface } from '../../../interfaces/collections/PlatformResellerCollectionInterface';

import Tree, { treeHandlers, useTreeState } from 'react-hyper-tree';
import { TreeNode } from 'react-hyper-tree/dist/helpers/node';
import ManageUsersButton from '../../../components/Buttons/ManageUsersButton';
import EditButton from '../../../components/Buttons/EditButton';
import BuildButton from '../../../components/Buttons/BuildButton';
import i18next from 'i18next';
import { ServicePartnerList } from '../../Features/ServicePartnerList';
import { FeaturesServiceReducerType, ServicesAction } from '../../../modules/features/FeaturesReducers';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import OPL_STYLE from '../../../assets/themes/OPL/OplStyle';
import COLORS from '../../../assets/themes/OPL/colors';
import DeleteButton from '../../../components/Buttons/DeleteButton';
import ReinstateButton from '../../../components/Buttons/ReinstateButton';

const _ = require('underscore');

export type ResellerMapItem = {
    id: number;
    name: string;
    parentResellerId: number | null;
    children: Array<ResellerMapItem>;
    resellerObject: PlatformResellerInterface;
};

export type PlatformResellerListProps = {
    showActions?: boolean;
    handleEdit?: (node: TreeNode) => void;
    handleManageUsers?: (node: TreeNode) => void;
    handleDelete?: (node: TreeNode) => void;
    handleReinstate?: (node: TreeNode) => void;
    handleSelect?: (node: TreeNode) => void;
    handleNumberRangeEdit?: (node: TreeNode) => void;
    formattedResellerList: ResellerMapItem[];
};

export const PlatformResellerList = (props: PlatformResellerListProps): React.ReactElement => {
    // const baseDeletedFilter = useMemo((): Filter => {
    //     return { name: 'deleted', value: 0 } as Filter;
    // }, []);
    const dispatch = useDispatch();
    const [selectedReseller, setSelectedReseller] = useState<number | null>(null);
    const { handleEdit, handleDelete, handleReinstate, showActions, handleSelect, handleManageUsers, handleNumberRangeEdit } = props;
    const [openAllowedComponents, setOpenAllowedComponents] = useState(false);
    const [platformReseller, setPlatformReseller] = useState<PlatformResellerInterface | null>(null);

    const { required, handlers } = useTreeState({
        id: 'tree',
        data: props.formattedResellerList,
        defaultOpened: true,
        multipleSelect: false,
    });

    const localHandleSelect = useCallback(
        (node: TreeNode): void => {
            setSelectedReseller(node.id as number);
            if (handleSelect) {
                handleSelect(node);
            }
        },
        [handleSelect]
    );

    const editComponentAllowed = useCallback(
        (node: TreeNode): void => {
            dispatch({
                type: ServicesAction.FEATURES_LOAD_SIM_CARD_SERVICE_TYPE_LIST,
                serviceList: undefined,
            } as FeaturesServiceReducerType);
            const data = node.data;
            setOpenAllowedComponents(true);
            setPlatformReseller(data.resellerObject);
        },
        [dispatch]
    );

    const isSelectedResellerDeleted = useCallback((node: TreeNode): boolean => {
        if (node.data.resellerObject.deleted === 1) {
            return true;
        }

        return false;
    }, []);

    const renderNode = useCallback(
        ({ node, onToggle }) => {
            //Todo: move applicable css to normal classes

            const treeNodeStyle = {
                display: 'flex',
                alignItems: 'center',
                minHeight: '40px',
                maxHeight: '40px',
            };

            const treeIconStyle = {
                marginRight: '8px',
                borderRadius: '50%',
                cursor: 'pointer',
                backgroundRepeat: 'no-repeat',
                width: '12px',
                height: '12px',
                backgroundSize: 'contain',
            };

            const treeIconOpen = {
                backgroundImage:
                    'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjQgNjQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDY0IDY0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHgxPSIzMiIgeTE9IjUwIiB4Mj0iMzIiIHkyPSIxNCIvPg0KCTxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHgxPSIxNCIgeTE9IjMyIiB4Mj0iNTAiIHkyPSIzMiIvPg0KPC9nPg0KPGc+DQoJPGNpcmNsZSBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBjeD0iMzIiIGN5PSIzMiIgcj0iMzAuOTk5Ii8+DQo8L2c+DQo8L3N2Zz4NCg==")',
            };

            const treeIconClose = {
                backgroundImage:
                    'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjQgNjQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDY0IDY0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHgxPSIxNCIgeTE9IjMxIiB4Mj0iNTAiIHkyPSIzMSIvPg0KPC9nPg0KPGc+DQoJPGNpcmNsZSBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBjeD0iMzIiIGN5PSIzMiIgcj0iMzAuOTk5Ii8+DQo8L2c+DQo8L3N2Zz4NCg==")',
            };

            const treeIconEmpty = {
                backgroundImage:
                    'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjQgNjQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDY0IDY0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxjaXJjbGUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgY3g9IjMyIiBjeT0iMzIiIHI9IjMwLjk5OSIvPg0KPC9nPg0KPC9zdmc+DQo=")',
            };

            const currentNodeTreeIcon = node.hasChildren()
                ? node.options.opened
                    ? { ...treeIconStyle, ...treeIconClose }
                    : { ...treeIconStyle, ...treeIconOpen }
                : { ...treeIconStyle, ...treeIconEmpty };

            const nodeStyle = {
                cursor: 'pointer',
                minHeight: '40px',
                maxHeight: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: isSelectedResellerDeleted(node) ? COLORS.MAIN.DARKGRAY : COLORS.MAIN.LIGHT,
                width: '100%',
                padding: '6px',
                boxShadow: '0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%)',
                transition: 'all .2s ease',
            };

            const nodeSelectedStyle = {
                borderLeft: `4px solid ${COLORS.MAIN.PRIMARY}`,
            };

            const currentNodeStyle = node.isSelected() ? { ...nodeStyle, ...nodeSelectedStyle } : { ...nodeStyle };

            const currentNodeChildrenStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '24px',
                height: '24px',
                backgroundColor: COLORS.MAIN.PRIMARY,
                color: COLORS.MAIN.LIGHT,
                padding: '4px',
                fontSize: '12px',
                borderRadius: '16px',
                marginLeft: '12px',
                fontWeight: 600,
            };

            const buttonsStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '24px',
                height: '16px',
                marginLeft: '12px',
            };

            return (
                <div style={treeNodeStyle} key={node.data.title}>
                    <div onClick={onToggle} style={currentNodeTreeIcon} />
                    <div
                        style={currentNodeStyle}
                        onClick={(): any => {
                            localHandleSelect(node);
                            treeHandlers.trees.tree.handlers.setSelected(node, true);
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'baseline',
                            }}
                        >
                            <div style={{ fontWeight: 600 }}>{node.data.name}</div>
                            {node.data.title && (
                                <div
                                    style={{
                                        marginTop: '4px',
                                        fontSize: '10px',
                                    }}
                                >
                                    {node.data.title}
                                </div>
                            )}
                            {!!node.options.childrenCount && (
                                <div style={currentNodeChildrenStyle}>
                                    <div>{node.options.childrenCount}</div>
                                </div>
                            )}
                        </div>
                        {showActions && (
                            <div style={buttonsStyle}>
                                <ManageUsersButton
                                    callback={(): void => {
                                        if (handleManageUsers) {
                                            handleManageUsers(node);
                                        }
                                    }}
                                    callbackParam={{}}
                                />
                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_RESELLER_PUT) && (
                                    <EditButton
                                        callback={(): void => {
                                            if (handleEdit) {
                                                handleEdit(node);
                                            }
                                        }}
                                        callbackParam={{}}
                                    />
                                )}
                                {/*<MenuBookButton*/}
                                {/*    callback={(): void => {*/}
                                {/*        if (handleNumberRangeEdit) {*/}
                                {/*            handleNumberRangeEdit(node);*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*    callbackParam={{}}*/}
                                {/*    tooltipTitle={'number_range:b.add_number_range'}*/}
                                {/*/>*/}
                                {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_PARTNER_ALLOWED_GET) && (
                                    <BuildButton
                                        title={i18next.t('prov:feature.partner_component_allowed')}
                                        callback={(): void => {
                                            editComponentAllowed(node);
                                        }}
                                        callbackParam={{}}
                                    />
                                )}
                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_RESELLER_DELETE) &&
                                    node.data.resellerObject.parentResellerId !== null &&
                                    node.data.resellerObject.deleted !== 1 &&
                                    !isSelectedResellerDeleted(node) && (
                                        <DeleteButton
                                            title={i18next.t('platform_reseller:pr.delete_platform_reseller')}
                                            callback={(): void => {
                                                if (handleDelete) {
                                                    handleDelete(node);
                                                }
                                            }}
                                            callbackParam={{}}
                                        />
                                    )}
                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_RESELLER_DELETE) &&
                                    node.data.resellerObject.parentResellerId !== null &&
                                    (node.data.resellerObject.deleted === 1 || isSelectedResellerDeleted(node)) && (
                                        <ReinstateButton
                                            title={i18next.t('platform_reseller:pr.reinstate_platform_reseller')}
                                            callback={(): void => {
                                                if (handleReinstate) {
                                                    handleReinstate(node);
                                                }
                                            }}
                                            callbackParam={{}}
                                        />
                                    )}
                            </div>
                        )}
                    </div>
                </div>
            );
        },
        [
            showActions,
            handleEdit,
            handleReinstate,
            handleDelete,
            localHandleSelect,
            handleManageUsers,
            editComponentAllowed,
            isSelectedResellerDeleted,
        ]
    );

    return (
        <div>
            {props.formattedResellerList && (
                <Tree
                    {...required}
                    {...handlers}
                    horizontalLineStyles={{
                        stroke: '#c4c4c4',
                        strokeWidth: 1,
                        strokeDasharray: '1 4',
                    }}
                    verticalLineStyles={{
                        stroke: '#c4c4c4',
                        strokeWidth: 1,
                        strokeDasharray: '1 4',
                    }}
                    draggable={false}
                    depthGap={20}
                    disableLines={false}
                    disableHorizontalLines={false}
                    disableVerticalLines={false}
                    verticalLineTopOffset={0}
                    verticalLineOffset={5}
                    renderNode={renderNode}
                />
            )}
            <ServicePartnerList
                platformReseller={platformReseller}
                open={openAllowedComponents}
                closeDialog={(): void => {
                    setPlatformReseller(null);
                    setOpenAllowedComponents(false);
                }}
            />
        </div>
    );
};

export default PlatformResellerList;
